<template>
  <div class="products">
    <h1 class="title">Catálogo</h1>
    <h2 class="description">Descubra os produtos criados e desenvolvidos pela Dengo e Arte!</h2>
    <ul class="product-list">
      <li v-for="(product, index) in products" :key="index">
        <Product :product="product" />
      </li>
    </ul>
  </div>
</template>

<script>
import Product from '@/components/Product.vue';

export default {
  components: { Product },
  mounted() {
    this.$store.dispatch('getProducts');
  },
  computed: {
    products() {
      window.scrollTo(0, 0);
      return this.$store.getters.products;
    },
  },
};
</script>

<style scoped>
.products {
  background-color: white;
  padding: 40px 0;
}

.title {
  color: #b62968;
  font-family: 'Poppins', sans-serif;
  text-align: center;
  margin: 0;
}

.description {
  color: #838383;
  text-align: center;
  margin: 5px auto 20px;
  padding: 0 40px;
}

.product-list {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  flex-wrap: wrap;
}

.more {
  width: 150px;
  padding: 5px 20px;
  border-radius: 25px;
  text-align: center;
  display: block;
  margin: 30px auto 0;
  text-transform: uppercase;
  background-color: #b62968;
  color: white;
  font-size: 14px;
}

@media screen and (max-width: 580px) {
  .product-list {
    flex-direction: column;
  }

  .title {
    font-size: 24px;
  }

  .description {
    font-size: 14px;
  }
}

@media screen and (min-width: 1044px) {
  .products {
    width: 1040px;
    margin: auto;
  }
}
</style>
